import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import muiThemeable from 'material-ui/styles/muiThemeable';

var LLSubmitButton = /*#__PURE__*/function (_Component) {
  _inherits(LLSubmitButton, _Component);

  var _super = _createSuper(LLSubmitButton);

  function LLSubmitButton() {
    _classCallCheck(this, LLSubmitButton);

    return _super.apply(this, arguments);
  }

  _createClass(LLSubmitButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: this.props.disabled,
        primary: true,
        label: this.props.label,
        fullWidth: true,
        style: this.props.style,
        type: 'submit',
        onSubmit: this.props.onSubmit,
        onClick: this.props.onClick
      });
    }
  }]);

  return LLSubmitButton;
}(Component);

_defineProperty(LLSubmitButton, "propTypes", {
  label: PropTypes.string,
  style: PropTypes.object,
  onSubmit: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  muiTheme: PropTypes.object.isRequired
});

_defineProperty(LLSubmitButton, "defaultProps", {
  label: 'Submit',
  style: {},
  onSubmit: null,
  onClick: undefined,
  disabled: false
});

export { LLSubmitButton as default };